import { Select } from "antd";
import UserTag from "components/user-tag/user-tag";
import { AcceptanceStatus, UserParticipationType } from "constants/index";
import { useProjectParticipants } from "hooks/project-participants";
import { useMemo } from "react";

const { Option } = Select;

function ProjectUserParticipantsDropdown(props: any) {
  const {
    value,
    notFoundContent,
    onChange,
    disabled,
    selectedCompanyId,
    userParticipationType,
    isIntegrationMode,
    selectedUserInfo
  } = props;
  const { projectParticipants } = useProjectParticipants();

  const projectUsers = useMemo(() => {
    if (isIntegrationMode) {
      const user = {
        id: selectedUserInfo?.user?.id,
        first_name: selectedUserInfo?.user?.first_name,
        last_name: selectedUserInfo?.user?.last_name,
        email: selectedUserInfo?.user?.email,
        type: "actual",
        status_id: selectedUserInfo?.user?.status_id
      };

      return [user];
    }

    let users = [];
    switch (userParticipationType) {
      case UserParticipationType.GC_REVIEWER:
        users = projectParticipants?.gcReviewers;
        break;
      case UserParticipationType.SUBMITTER:
        users = projectParticipants?.submitterUsers;
        break;
      case UserParticipationType.DESIGN_REVIEWER:
        users = projectParticipants?.designReviewers;
        break;
      default:
        users = [];
        break;
    }

    if (selectedCompanyId) {
      return users?.filter(
        (user: any) =>
          selectedCompanyId &&
          user &&
          user?.company?.vendor_id === selectedCompanyId
      );
    }

    return users;
  }, [
    userParticipationType,
    selectedCompanyId,
    isIntegrationMode,
    projectParticipants?.gcReviewers,
    projectParticipants?.submitterUsers,
    projectParticipants?.designReviewers,
    selectedUserInfo
  ]);

  return (
    <Select
      className="w-full"
      loading={!projectParticipants?.dataLoaded}
      value={projectParticipants?.dataLoaded ? value : undefined}
      allowClear
      onChange={onChange}
      showSearch
      filterOption={(inputValue, option: any) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
      optionFilterProp="label"
      notFoundContent={notFoundContent}
      disabled={disabled}
      data-testid="projectparticipantsdropdown-select"
    >
      {projectUsers?.map((user: any) => {
        if (
          (user?.status_id === AcceptanceStatus.DEACTIVATED &&
            user?.id !== value?.toString()) ??
          ""
        )
          return "";

        const selectedAndInactive =
          (user?.status_id === AcceptanceStatus.DEACTIVATED &&
            user?.id === value?.toString()) ??
          "";
        return (
          <Option
            key={user?.id}
            value={user?.id}
            label={`${user?.first_name} ${user?.last_name} ${user?.company?.name}`}
            firstName={user?.first_name}
            lastName={user?.last_name}
            className={selectedAndInactive ? "hidden" : ""}
          >
            {user?.status_id === AcceptanceStatus.DEACTIVATED && (
              <div className="absolute flex w-full items-center justify-end pr-3 -mt-[1px]">
                <UserTag label="Inactive" />
              </div>
            )}
            <div>
              {user?.first_name} {user?.last_name}
            </div>
            <div className="text-sm text-gray-500">{user?.company?.name}</div>
          </Option>
        );
      })}
    </Select>
  );
}

export default ProjectUserParticipantsDropdown;
